<template>
    <div>
        <div id='basket_section' class='basket-section' @mouseover='hoverBasket' @click='openCart'>
            <div class='basket-hover-buffer'></div>
            <div class='basket-container'>
                <span class="fa-layers fa-fw basket-icon">
                    <i class="fa-regular fa-cart-shopping"></i>
                    <span class="fa-layers-counter basket-counter">{{total_items}}</span>
                </span>
                <span class="basket-amount">{{cart_total}}</span>
            </div>
        </div>

        <SidePopOut id='basket_popout' :open_watcher='open_basket_watcher' :close_watcher='close_basket_watcher'>
            <BasketPopout :cart='cart' :cart_total='cart_total' :total_items='total_items' @continueToCheckoutListener='continueToCheckout' @closePopOutListener='closePopout' @updatedCartListener='getCart' :open_watcher='open_basket_watcher'/>
        </SidePopOut>
    </div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue';
import BasketPopout from '@/ecom/components/navigation/header/basket/BasketPopout.vue';
import Loading from '@/ecom/components/loading/Loading.vue';
import SidePopOut from '@/ecom/components/overlays/SidePopOut.vue'

import {checkAuth, formatNumber} from "@/global/modules/functions.js";

export default {
    components: {Button, Loading, BasketPopout, SidePopOut},
    emits:['updatedCartListener'],
    props: ['updated_cart_watcher'],
    data(){
        return{
            cart: [],
            timeout: null,
            cart_total: formatNumber(0.00),
            basketUpdated: null,
            total_items: 0,
            loading: false,
            open_basket_watcher: null,
            close_basket_watcher: null
        }
    },
    
    methods:{
        closePopout(){
            this.close_basket_watcher = +new Date();
        },
        async getCart(){
            this.$emit('updatedCartListener');
            this.loading = true;
            let response = await fetch(`/api/cart`, {
                method: 'GET'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.cart = results.cart;
                this.cart_total = formatNumber(results.total_excl_vat);
                this.total_items = results.total_items;
                this.loading = false;
            }
        },
        openCart(){
            this.open_basket_watcher = +new Date();
        },
        continueToCheckout(){
            this.closePopout();
            this.$router.push('/cart');
        },
        hoverBasket(){
            // this.showBasket();
        },
        handleBasketHover(){
            // const isHover = e => e.parentElement.querySelector(':hover') === e;
            
            // let self = this;

            // document.addEventListener('mousemove', function checkBasketHover() {
            //     const basket_section = isHover(document.getElementById('basket_section'));

            //     if (basket_section !== checkBasketHover.hovered) {
            //         if(!basket_section){
            //             self.hideBasket();
            //         }

            //         checkBasketHover.hovered = basket_section;
            //     }
            // });
        },
        showBasket(){
            // document.getElementById('basket_popout').classList.remove('hidden');
        },
        hideBasket(){
            // document.getElementById('basket_popout').classList.add('hidden');
    },
    watchForOutletSwitch(){
            window.addEventListener('storage', (event) => {   //Watch for local storage changes, this is done so can track changes across windows or tabs
                if(event.key === 'selected_outlet_watcher') {
                    setTimeout(() => {
                        this.getCart();
                    }, 1);
                }
            });
        }
    },
    mounted(){
        // this.handleBasketHover();
    },
    beforeMount(){
        this.getCart();
        this.watchForOutletSwitch();
    },
    watch:{
        'updated_cart_watcher': function(){
            this.getCart();
        }
    }
}
</script>

<style lang="scss" scoped>

.price{
    @media(max-width: 768px){
        display: none;
    }
}

.basket-section{
    position: relative;
    display:flex;
    gap: 30px;
    align-items: center;
    cursor: pointer;

    @media(max-width: 768px){
        gap: 0px;
    }
}

.basket-container{
    display: flex;
    gap: 12px;
    align-items: center;
}

.basket-hover-buffer{
    top: 0; 
    width: 60px; 
    height: 50px; 
    margin-left: -10px;
    position:absolute; 
    opacity: 0;

    @media(max-width:768px){
        width: 50px;
    }
}

.basket-icon{
    font-size: 1.6rem;

    // margin-top:-2px;
     @media(max-width:768px){
        font-size: 1.195rem;
    }
}

.basket-counter{
    font-size: 2.6rem;
    background-color: var(--primary-colour-1);
    margin-right: -3px;
    margin-top: -3px;
}

.basket-amount{
    font-size: 1rem;
    line-height: 22px;
    @media(max-width:768px){
        font-size: 0.85rem;
    }
}

.total-container{
    height: 34px;
    align-content: center;
    width: 50px;

    @media(max-width: 768px){
        display:none;
    }
}

.loading-container{
    margin-left: 10px;
    width: 20px; 
    height: 20px;
}

</style>